module.exports = __webpack_public_path__ + "static/media/logo-residencia.e44ae0f0.svg";